import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LogIn from "./pages/LogIn";
import PreRegistration from "./pages/PreRegistration";
import RegistrationAddress from "./pages/RegistrationAddress";
import SetPassword from "./pages/SetPassword";
import RegistrationBusiness from "./pages/RegistrationBusiness";
import Dashboard from "./pages/Dashboard";
import Leads from "./pages/Leads";
import Responses from "./pages/Responses";
import Settings from "./pages/Settings";
import HelpSupport from "./pages/HelpSupport";
import MyProfile from "./pages/MyProfile";
import PortfolioDetail from "./pages/PortfolioDetail";
import Accreditations from "./pages/Accreditations";
import Employee from "./pages/Employee";
import Reviews from "./pages/Reviews";
import GetVerified from "./pages/GetVerified";
import PremiumMemberships from "./pages/PremiumMemberships";
import AccountDetails from "./pages/AccountDetails";
import AccountSecurity from "./pages/AccountSecurity";
import YourServices from "./pages/YourServices";
import ContactPreferences from "./pages/ContactPreferences";
import Credits from "./pages/Credits";
import Invoices from "./pages/Invoices";
import YourSubscription from "./pages/YourSubscription";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoute from "./utils/ProtectedRoute";
import PrivatePublicRoute from "./utils/PrivatePublicRoute";
import LandingPage from "./pages/LandingPage";
import ProtectCustomerRoutes from "./utils/ProtectCustomerRoutes";
import YourEnquiries from "./pages/YourEnquiries";
import PageNotFound from "./pages/PageNotFound";
import YourFavourites from "./pages/YourFavourites";
import ProectPasswordScreens from "./utils/ProectPasswordScreens";
import CustomerAccount from "./pages/CustomerAccount";
import CustomerDashboard from "./pages/CustomerDashboard";
import CustomerEnquiriesDetail from "./pages/CustomerEnquiriesDetail";
import { LeadDetailProvider } from "./context/LeadDetailProvider";
import ElectricianProfile from "./pages/ElectricianProfile";
import AllTeamMembers from "./pages/AllTeamMembers";
import VendorPortfolioDetail from "./pages/VendorPortfolioDetail";
import { LoginProvider } from "./context/LoginContext";
import PaymentFailed from "./pages/PaymentFailed";
import Review from "./pages/Review";
import LeaveReview from "./pages/LeaveReview";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Refer from "./pages/Refer";
import VendorJoin from "./pages/VendorJoin";
import RegisPasswordSet from "./pages/RegisPasswordSet";
import OtpVerification from "./pages/OtpVerification";
import CustomerSupport from "./pages/CustomerSupport";
import ElectricianReviews from "./pages/ElectricianReviews";
import CustomerFaqs from "./pages/CustomerFaqs";
import VendorFaqs from "./pages/VendorFaqs";
import AnalyticsTag from "./Componants/AnalyticsTag";

function App() {
  return (
    <>
     <AnalyticsTag />
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/customer-faqs" element={<CustomerFaqs />}></Route>
          <Route path="/vendor-faqs" element={<VendorFaqs />}></Route>
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route element={<ProectPasswordScreens />}>
            <Route path="/set-password" element={<SetPassword />} />
          </Route>
          <Route element={<PrivatePublicRoute />}>
            <Route path="/" element={<LandingPage />}></Route>
            <Route path="/login" element={<LogIn />}></Route>

            <Route path="/forgot-password" element={<ForgotPassword />}></Route>
            <Route
              path="/pre-registration"
              element={<PreRegistration />}
            ></Route>
            <Route path="/join" element={<VendorJoin />}></Route>

            <Route
              path="/registration-address"
              element={<RegistrationAddress />}
            ></Route>
            <Route
              path="/registration-business"
              element={<RegistrationBusiness />}
            ></Route>
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route
              path="/registration-password"
              element={<RegisPasswordSet />}
            ></Route>
            <Route
              path="/registration-otp"
              element={<OtpVerification />}
            ></Route>
          </Route>
          <Route
            element={
              <LoginProvider>
                <ProtectedRoute />
              </LoginProvider>
            }
          >
            <Route path="/dashboard" element={<Dashboard />}></Route>

            <Route
              path="/leads"
              element={
                <LeadDetailProvider>
                  <Leads />
                </LeadDetailProvider>
              }
            ></Route>
            <Route path="/responses" element={<Responses />}></Route>
            <Route path="/settings" element={<Settings />}></Route>

            <Route path="/help-support" element={<HelpSupport />}></Route>
            <Route path="/my-profile" element={<MyProfile />}></Route>
            <Route
              path="/portfolio-detail"
              element={<PortfolioDetail />}
            ></Route>
            <Route path="/accreditations" element={<Accreditations />}></Route>
            <Route path="/employee" element={<Employee />}></Route>
            <Route path="/Payment-failed" element={<PaymentFailed />}></Route>

            <Route path="/get-verified" element={<GetVerified />}></Route>
            <Route
              path="/premium-memberships"
              element={<PremiumMemberships />}
            ></Route>
            <Route path="/reviews" element={<Review />}></Route>
            <Route path="/refer" element={<Refer />}></Route>
            <Route path="/account-details" element={<AccountDetails />}></Route>
            <Route
              path="/account-security"
              element={<AccountSecurity />}
            ></Route>
            <Route path="/your-services" element={<YourServices />}></Route>
            <Route
              path="/contact-preferences"
              element={<ContactPreferences />}
            ></Route>
            <Route path="/credits" element={<Credits />}></Route>
            <Route path="/invoices" element={<Invoices />}></Route>
            <Route
              path="/your-subscription"
              element={<YourSubscription />}
            ></Route>
          </Route>

          <Route element={<ProtectCustomerRoutes />}>
            <Route
              path="/customer-dashboard"
              element={<CustomerDashboard />}
            ></Route>
            <Route path="/your-enquiries" element={<YourEnquiries />}></Route>
            <Route path="/your-favourites" element={<YourFavourites />}></Route>
            <Route
              path="/customer-account"
              element={<CustomerAccount />}
            ></Route>
            <Route path="/support" element={<CustomerSupport />}></Route>
            <Route
              path="/enquiry-detail/:id"
              element={<CustomerEnquiriesDetail />}
            ></Route>
            <Route
              path="/electrician-profile"
              element={<ElectricianProfile />}
            ></Route>
            <Route
              path="/electrician-reviews"
              element={<ElectricianReviews />}
            ></Route>
            <Route
              path="/all-team-members"
              element={<AllTeamMembers />}
            ></Route>
            <Route
              path="/profile-portfolio-detail"
              element={<VendorPortfolioDetail />}
            ></Route>
            <Route path="/leave-review" element={<LeaveReview />}></Route>
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
    </>
  );
}

export default App;
